import { render, staticRenderFns } from "./ColetaMaterial.vue?vue&type=template&id=11b65778&"
import script from "./ColetaMaterial.vue?vue&type=script&lang=js&"
export * from "./ColetaMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports